import React from "react";
const PlaySvg = () => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13085 24C2.72147 23.9993 2.31934 23.8943 1.96402 23.6954C1.16391 23.252 0.666504 22.3911 0.666504 21.4565V2.54358C0.666504 1.60641 1.16391 0.748155 1.96402 0.304679C2.3278 0.100182 2.74107 -0.0049813 3.16062 0.000181328C3.58017 0.00534396 3.99061 0.120643 4.34902 0.334027L20.8747 10.0096C21.2191 10.2209 21.503 10.5142 21.6998 10.8621C21.8966 11.21 21.9998 11.6011 21.9998 11.9988C21.9998 12.3964 21.8966 12.7875 21.6998 13.1354C21.503 13.4833 21.2191 13.7766 20.8747 13.9879L4.34635 23.6661C3.97956 23.883 3.55945 23.9984 3.13085 24Z"
        fill="white"
      />
    </svg>
  );
};

export default PlaySvg;
